import React, { Component } from "react";
import "./Home.css";
import grocery from "../images/grocery-list.jpg";
import blink from "../images/dontblink.svg";
import joy from "../images/joy.svg";
import place from "../images/placeorder.svg";
class Home extends Component {
  render() {
    return (
      <>
        <div className="container my-5">
          <div className="row">
            <div className="row text-center">
              <h1>
                <span className="change text-center"> </span>
                <br />
                DELIVERED IN MINUTES
              </h1>
            </div>
            <div className="row my-5">
              <img className="img-thumbnail" alt="" src={grocery} />
            </div>
          </div>
        </div>
        <div className="container ">
          <h1 className="text-center py-5">DELIVERING TO</h1>
          <div className="container">
            <div
              id="carouselExampleAutoplaying"
              class="carousel slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <h1 className="text-center text-info">ROHTAK</h1>
                  {/* <img src="..." class="d-block w-100" alt="..." /> */}
                </div>
                <div class="carousel-item">
                  <h1 className="text-center text-info">SONIPAT</h1>
                  {/* <img src="..." class="d-block w-100" alt="..." /> */}
                </div>
                <div class="carousel-item">
                  <h1 className="text-center text-info">BAHADURGARH</h1>
                  {/* <img src="..." class="d-block w-100" alt="..." /> */}
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleAutoplaying"
                data-bs-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleAutoplaying"
                data-bs-slide="next"
              >
                <span
                  class="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>

          <p className="text-center">
            Is Your City Missing ? Don't Worry, We're{" "}
            <u>
              <a href="/Delivery">Coming Soon</a>
            </u>
          </p>
        </div>
        <div className=" container">
          <h3 className="text-center my-5">How it Works</h3>
          <div className="fourth-div row mx-3">
            <div className="col text-center">
              <img src={place} alt="" />
              <h1 className="my-5">Place an Order</h1>
              <p className="text-center">
                Choose from a wide range of daily essentials
              </p>
            </div>
            <div className="col text-center">
              <img src={joy} alt="" />
              <h1 className="my-5">Enjoy</h1>
              <p className="text-center">
                Boom! You'll never have to wait for groceries again
              </p>
            </div>
            <div className="col text-center">
              <img src={blink} alt="" />
              <h1>Don't Blink</h1>
              <p className="text-center">
                Our delivery partner will be at your door
              </p>
            </div>
          </div>
        </div>
        <h1 className="text-center my-5">HAPPY CUSTOMERS</h1>

        <div className="container">
          <div className="row">
            <div className="col ">
              <blockquote className="pinkblock fs-5 px-5 py-5">
                Impressed with the overall experience. Placed an order on GIMS
                right after booking a cab.The order arrived faster than the
                cab!!
                <h3 className="my-5">Abhishek</h3>
              </blockquote>
            </div>
            <div className="col">
              <blockquote className="blueblock fs-5 px-5 py-5">
                I no longer have to plan in advance for my groceries. This
                service helps me order on-the- fly. 10 minute delivery is just
                insane
                <h3 className="my-5">Sunny</h3>
              </blockquote>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col">
              <blockquote className="blueblock fs-5 px-5 py-5">
                This service is unbelievably fast. And their product assortment
                is great!
                <h3 className="my-5 py-4">Ajay</h3>
              </blockquote>
            </div>
            <div className="col">
              <blockquote className="pinkblock fs-5 px-5 py-5">
                Thank you for being an absolute saviour. Best app for when you
                need something INSTANTLY
                <h3 className="my-5 py-4">Gautam</h3>
              </blockquote>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default Home;
